import { React, useRef, useState, useEffect } from "react";
import "./css/Projects.css";
import { TextField } from "@material-ui/core";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Divider, InputAdornment } from "@mui/material";
import Project from "./components/Project";
import Grid from "@mui/material/Grid";
import { getFirestore, collection, getDocs, where, query } from "./firebase";
import { render } from "@testing-library/react";
import searchImage from "./images/search.png";
import Header from "./components/Header";
// import InputAdornment from  '@mui/material/InputAdornment'

let clickedBtns = [
  "all"
];
let prj = null;
let isProjects = false;

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [tempProjects, setTempProjects] = useState([]);
  const [tempStr, setTempStr] = useState([]);

  const db = getFirestore();

  const projectsColl = collection(db, "projects");

  let docs = getDocs(projectsColl);

  const getProjects = () => {
    docs.then((res) => {
      let tempArr = [];
      res.forEach((doc) => {
        let projectImage = doc.get("projectImage");
        let projectName = doc.get("projectName");
        let projectDesc = doc.get("projectDesc");
        let projectRepoUrl = doc.get("projectRepoUrl");
        let projectUrl = doc.get("projectUrl");
        let projectTech = doc.get("projectTech");

        tempArr.push({
          projectImage,
          projectName,
          projectDesc,
          projectRepoUrl,
          projectTech,
          projectUrl,
        });
      });
      setTempProjects(tempArr);
      setProjects(tempArr);
    });
  };

  prj = projects.map((item, index) => {
    return (
      <Grid key={index} item xs={15} sm={6}>
        <Project
          projectImage={item.projectImage}
          projectName={item.projectName}
          projectDesc={item.projectDesc}
          projectRepoUrl={item.projectRepoUrl}
          projectUrl={item.projectUrl}
          projectTech={item.projectTech}
        />
      </Grid>
    );
  });

  useEffect(() => {
    getProjects();
  }, []);

  useEffect(() => {
    isProjects = true;
  }, [getProjects]);

  

  const onSearchTextChanged = (text) => {

 
    let fillterdProjects = tempProjects.filter((data) => {
      return data.projectName
        .toLowerCase()
        .includes(text.toLowerCase())
        ? data
        : "";
    });

    setProjects(fillterdProjects);
  };

  const filterBtnClick = async (btnName) => {
    if (!clickedBtns.includes(btnName)) {
      clickedBtns.push(btnName);
    }

    if (clickedBtns.length > 1) {
      let btn1 = document.getElementById(clickedBtns[0]);
      let btn2 = document.getElementById(clickedBtns[1]);
      btn2.classList.add("filterBtnAfterClick");
      btn1.classList.remove("filterBtnAfterClick");

      clickedBtns[0] = clickedBtns[1];

      clickedBtns.pop();
    } else {
      let btn = document.getElementById(clickedBtns[0]);
      btn.classList.add("filterBtnAfterClick");
    }

    let querySnapshot = null;
    let documents = null;

    if (btnName == "all") {
      documents = await getDocs(projectsColl);
    } else {
      querySnapshot = await query(
        projectsColl,
        where("projectType", "==", btnName)
      );
      documents = await getDocs(querySnapshot);
    }

    let tempArr = [];
    documents.forEach((doc) => {
      let projectImage = doc.get("projectImage");
      let projectName = doc.get("projectName");
      let projectDesc = doc.get("projectDesc");
      let projectRepoUrl = doc.get("projectRepoUrl");
      let projectUrl = doc.get("projectUrl");
      let projectTech = doc.get("projectTech");

      tempArr.push({
        projectImage,
        projectName,
        projectDesc,
        projectRepoUrl,
        projectTech,
        projectUrl,
      });
    });
    setProjects(tempArr);
  };

  return (
    <>
      <Header />
      <div className="projects">
        <h1 className="projectsTitle">Projects</h1>

        <div className="searchDiv">
          <img className="searchIcon" src={searchImage} alt="" srcset="" />
          <input
            className="searchInp"
            onChange={(e) => onSearchTextChanged(e.target.value)}
            placeholder="Search"
          />
        </div>

        <div className="filterBtnsDiv">
          <button
            className="filterBtn"
            id="website"
            onClick={() => filterBtnClick("website")}
          >
            Web apps
          </button>
          <button
            className="filterBtn"
            id="mobileapp"
            onClick={() => filterBtnClick("mobileapp")}
          >
            Mobile apps
          </button>
          <button
            className="filterBtn filterBtnAfterClick"
            id="all"
            onClick={() => filterBtnClick("all")}
          >
            Any
          </button>
        </div>
        <Divider sx={{ marginLeft: "5px", marginBottom: "30px" }} />

        <Grid className="projectsContainer" container spacing={4}>
          {projects.length > 0 ? (
            prj
          ) : (
            <h2 className="noprojects">No Projects</h2>
          )}
        </Grid>
      </div>
    </>
  );
};

export default Projects;
